import { render } from "./ClickHere.vue?vue&type=template&id=87917878"
import script from "./ClickHere.vue?vue&type=script&lang=js"
export * from "./ClickHere.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__